/**
 * @generated SignedSource<<2832772b4cc969c723b37dd89bac0569>>
 * @relayHash af579b7ccd18225f53e0ba7e5997759c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID a304af1dcdc7cca397f23a09fa40f823a65f467687010593a4d8d90c922bb448

import type { ConcreteRequest, Mutation } from 'relay-runtime';
export type MoveToPersonalSpaceFlagTriggerMovePageAppendMutation$variables = {
  pageId: string;
  parentId: string;
};
export type MoveToPersonalSpaceFlagTriggerMovePageAppendMutation$data = {
  readonly movePageAppend: {
    readonly page: {
      readonly id: string | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type MoveToPersonalSpaceFlagTriggerMovePageAppendMutation = {
  response: MoveToPersonalSpaceFlagTriggerMovePageAppendMutation$data;
  variables: MoveToPersonalSpaceFlagTriggerMovePageAppendMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "pageId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "parentId"
  }
],
v1 = [
  {
    "args": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "pageId",
            "variableName": "pageId"
          },
          {
            "kind": "Variable",
            "name": "parentId",
            "variableName": "parentId"
          }
        ],
        "kind": "ObjectValue",
        "name": "input"
      }
    ],
    "concreteType": "MovePagePayload",
    "kind": "LinkedField",
    "name": "movePageAppend",
    "plural": false,
    "selections": [
      {
        "concreteType": "Page",
        "kind": "LinkedField",
        "name": "page",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "id"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "MoveToPersonalSpaceFlagTriggerMovePageAppendMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "MoveToPersonalSpaceFlagTriggerMovePageAppendMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "af579b7ccd18225f53e0ba7e5997759c",
    "id": "a304af1dcdc7cca397f23a09fa40f823a65f467687010593a4d8d90c922bb448",
    "metadata": {},
    "name": "MoveToPersonalSpaceFlagTriggerMovePageAppendMutation",
    "operationKind": "mutation",
    "text": "mutation MoveToPersonalSpaceFlagTriggerMovePageAppendMutation($pageId:ID!,$parentId:ID!){movePageAppend(input:{pageId:$pageId,parentId:$parentId}){page{id}}}"
  }
};
})();

(node as any).hash = "79cbc17b214968c2ed046eeef92a15d0";

export default node;
